"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash"));
var _reactOnclickoutside = _interopRequireDefault(require("react-onclickoutside"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); } /* eslint new-cap: 0 */ /* global PSSessions, analyticsIntegrations */
var ActivityDropdown = /*#__PURE__*/function (_React$Component) {
  _inherits(ActivityDropdown, _React$Component);
  function ActivityDropdown(props) {
    var _this;
    _classCallCheck(this, ActivityDropdown);
    _this = _callSuper(this, ActivityDropdown, [props]);
    _this.handleClickOutside = _this.handleClickOutside.bind(_assertThisInitialized(_this));
    _this.optionList = _this.optionList.bind(_assertThisInitialized(_this));
    _this.highlightText = _this.highlightText.bind(_assertThisInitialized(_this));
    _this.checkSelected = _this.checkSelected.bind(_assertThisInitialized(_this));
    _this.removeHovered = _this.removeHovered.bind(_assertThisInitialized(_this));
    _this.renderDropOptions = _this.renderDropOptions.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(ActivityDropdown, [{
    key: "handleClickOutside",
    value: function handleClickOutside(e) {
      var clickOutsideClass = this.props.clickOutsideClass;
      var ignoreClickOutside = $(e.target).hasClass(clickOutsideClass || 'ignore-clickoutside');
      if (this.props.enableClickOutside && !ignoreClickOutside) {
        this.props.closeDropdown();
        if (this.props.suggestions) {
          if (!$('#act-list-0 a').hasClass('hovered')) {
            $('#act-list-0 a').addClass('hovered');
          }
        }
      }
    }
  }, {
    key: "optionList",
    value: function optionList(props) {
      var hideSeeMoreActivity = this.props.hideSeeMoreActivity;
      return /*#__PURE__*/_react.default.createElement("li", _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
        role: "presentation",
        key: "activity-list-".concat(props.index),
        id: "act-list-".concat(props.index)
      }, "role", "presentation"), "data-name", props.name), "data-id", props.id), "className", "border-bottom searchbar-metro-option"), "onClick", props.clickFn), "tabIndex", "-1"), "onFocus", this.removeHovered), props.miscList ? /*#__PURE__*/_react.default.createElement("div", {
        className: "more-cities"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row-height"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-9 col-height col-middle ellipsis"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: "#",
        onClick: this.props.seeMoreAction
      }, "See all popular activities"))))) : /*#__PURE__*/_react.default.createElement("a", {
        href: "#",
        className: "".concat(props.selected, " ").concat(props.hovered)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row-height"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-9 col-height col-middle"
      }, props.highlighted_name)))));
    }
  }, {
    key: "highlightText",
    value: function highlightText(matchedSubstring, description) {
      var strings = matchedSubstring.toLowerCase().split(' ');
      var drop = description.dropdown;
      var word = drop.toLowerCase();
      var wordLength = drop.length;
      var matches = [];
      _lodash.default.each(strings, function (str) {
        var index = word.indexOf(str);
        if (-1 !== index) {
          matches.push({
            index: index,
            length: str.length
          });
        }
      });
      var orderedMatches = _lodash.default.sortBy(matches, 'index');
      // starting point is 0
      var start = 0;
      // for each match, take the index
      var renderDropString = function renderDropString() {
        return _lodash.default.map(orderedMatches, function (match) {
          var index = match.index,
            length = match.length;
          if (!length || start > index) {
            return;
          }
          var normal;
          // if the index - starting point is greater than 0,
          var charsBefore = index - start;
          if (0 < charsBefore) {
            // create a substring from startingpoint to startingPoint + index;
            normal = drop.substr(start, charsBefore);
          }
          // take substring from index through length and make bold
          var bold = drop.substr(index, length);
          // new starting point is next index
          start = index + length;
          return /*#__PURE__*/_react.default.createElement("span", {
            key: "drop-".concat(index)
          }, /*#__PURE__*/_react.default.createElement("span", {
            className: "text-gray"
          }, normal), /*#__PURE__*/_react.default.createElement("span", {
            className: "bold"
          }, bold));
        });
      };
      // if after look the starting point is < length + 1, make another regular string
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "ellipsis"
      }, renderDropString(), start < wordLength ? /*#__PURE__*/_react.default.createElement("span", {
        className: "text-gray"
      }, drop.substring(start)) : null);
    }
  }, {
    key: "checkSelected",
    value: function checkSelected(optionProps) {
      var activityValue = this.props.activityValue;
      if (activityValue && activityValue === optionProps.name) {
        this.removeHovered();
        return 'dropdown-selected';
      }
    }
  }, {
    key: "removeHovered",
    value: function removeHovered() {
      $('#act-list-0 a').removeClass('hovered');
    }
  }, {
    key: "renderDropOptions",
    value: function renderDropOptions(props) {
      var _this2 = this;
      var optionsArray = [];
      var defaults = props.defaults,
        suggestions = props.suggestions,
        clickFn = props.clickFn,
        activityValue = props.activityValue,
        hideSeeMoreActivity = props.hideSeeMoreActivity;
      if (suggestions && suggestions.length) {
        optionsArray = suggestions.map(function (suggestion, i) {
          var hovered;
          if (0 === i) {
            hovered = 'hovered';
          }
          return {
            hovered: hovered || '',
            highlighted_name: _this2.highlightText(activityValue, suggestion),
            active: true,
            name: suggestion.dropdown,
            id: suggestion.id,
            usetype: suggestion.space_use,
            subtype: suggestion.use_subtype
          };
        });
        if (!hideSeeMoreActivity) {
          optionsArray.push({
            miscList: true
          });
        }
      } else {
        optionsArray = _lodash.default.map(defaults, function (suggestion) {
          return {
            name: suggestion.dropdown,
            id: suggestion.id,
            usetype: suggestion.space_use,
            subtype: suggestion.use_subtype
          };
        });
        if (!hideSeeMoreActivity) {
          optionsArray.push({
            miscList: true
          });
        }
      }
      return optionsArray.map(function (option, i) {
        var optionProps = option;
        optionProps.highlighted_name = option.highlighted_name || option.name;
        optionProps.clickFn = option.miscList ? null : clickFn;
        optionProps.index = i;
        optionProps.selected = _this2.checkSelected(optionProps);
        return _this2.optionList(optionProps);
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("ul", {
        role: "menu",
        "aria-expanded": "false",
        onMouseEnter: this.removeHovered,
        className: "dropdown-menu city-dropdown"
      }, this.renderDropOptions(this.props));
    }
  }]);
  return ActivityDropdown;
}(_react.default.Component);
ActivityDropdown.propTypes = {
  suggestions: _propTypes.default.array,
  defaults: _propTypes.default.array,
  clickFn: _propTypes.default.func,
  seeMoreAction: _propTypes.default.func,
  activityValue: _propTypes.default.string,
  enableClickOutside: _propTypes.default.bool,
  closeDropdown: _propTypes.default.func,
  origin: _propTypes.default.string,
  hideSeeMoreActivity: _propTypes.default.bool
};
exports.ActivityDropdown = (0, _reactOnclickoutside.default)(ActivityDropdown);